<template>
	<div class="statisticalAnalysis disBetween">
		<div class="statisticalLeft">
			<div class="itemTitleBox disStart">
				<div class="disStart">
					<span class="title">设备统计</span>
				</div>
			</div>
			<div class="listBox">
				<div class="contentBox scrollContBox">
					<ul ref="scrollview" class="scrollUl">
						<li class="scrollLi disCenter" :class="{active:active==1}" >
							<div class="imgBox img1"></div>
							<div class="itemBox ">
								<div class="valueBox">
									设备总数量
								</div>
								<div class="valueBox">
									<span>{{recordObj.equipmentCount}}</span>台
								</div>
							</div>
						</li>
						<li class="scrollLi disCenter" :class="{active:active==1}" >
							<div class="imgBox img2"></div>
							<div class="itemBox ">
								<div class="valueBox">
									正常设备数量
								</div>
								<div class="valueBox ">
									<span class="green">{{recordObj.equipmentNormalCount}}</span>台
								</div>
							</div>
						</li>
						<li class="scrollLi disCenter scrollLiAct" :class="{active:active==2}" @click="showErr">
							<div class="imgBox img3"></div>
							<div class="itemBox " >
								<div class="valueBox">
									异常设备数量
								</div>
								<div class="valueBox ">
									<span class="red">{{recordObj.equipmentUnNormalCount}}</span>台
								</div>
							</div>
						</li>
						<li class="scrollLi disCenter" :class="{active:active==3}" >
							<div class="imgBox img4"></div>
							<div class="itemBox ">
								<div class="valueBox">
									未安装设备数量
								</div>
								<div class="valueBox">
									<span class="grey">{{recordObj.unInstallEquipmentCount}}</span>台
								</div>
							</div>
						</li>
						<li class="scrollLi disCenter scrollLiAct" :class="{active:active==4}" @click="showequipmentErr">
							<div class="imgBox img3"></div>
							<div class="itemBox ">
								<div class="valueBox">
									故障设备数量
								</div>
								<div class="valueBox ">
									<span class="red">{{recordObj.equipmentFaultCount}}</span>台
								</div>
							</div>
						</li>
					</ul>
				</div>
			</div>
		</div>
		<el-dialog title="异常设备列表" center class="mydialog" :close-on-click-modal="NOfalse"
			:visible.sync="dialogOperation3" width="90%">
			<div class="dialogBox dialogBox2">
				<!-- <div class="diaItem disBetween">
					<div class="myinputBox">
						<el-date-picker v-model="searchObj2.searchData" type="daterange" range-separator="~"
							value-format="yyyy-MM-dd" start-placeholder="开始日期" end-placeholder="结束日期">
						</el-date-picker>
					</div>
					<el-button type="success" @click="getoperationData">查询</el-button>
				</div> -->
				<div class="myTable myTable2" v-loading="loading2">
					<el-table :data="operationData" style="width: 100%" height="450" row-key="id" 
						:expand-row-keys="expandRowKeys"
						:default-expand-all="defaultAll"
						:tree-props="{children: 'children', hasChildren: 'hasChildren'}">
						<!-- <el-table-column type="index" label="序号">
						</el-table-column> -->
						<el-table-column show-overflow-tooltip prop="communityName" label="所属社区" width="150">
						</el-table-column>
						<el-table-column show-overflow-tooltip prop="equipmentServiceProvider" label="运营商">
						</el-table-column>
						<el-table-column show-overflow-tooltip prop="communityEquipmentNo" label="设备编号">
							<template slot-scope="scope">
								<div>
									<span v-if="scope.row.children">
										异常:<span class="red">{{scope.row.children.length}}</span>
									</span>
									<span v-else>{{scope.row.communityEquipmentNo}}</span>
								</div>
							</template>
						</el-table-column>
						<el-table-column show-overflow-tooltip prop="communitySiteName" label="设备位置">
						</el-table-column>
						<el-table-column show-overflow-tooltip prop="communityEquipmentNo" label="使用率(日)">
							<template slot-scope="scope">
								<div class="clickUndline">
									<span class="green"
										v-if=" scope.row.dayUseCount>=5 ">{{((scope.row.dayUseCount/10)*100).toFixed(0)}}%</span>
									<span class="orange"
										v-if="scope.row.dayUseCount>=3 && scope.row.dayUseCount<5">{{((scope.row.dayUseCount/10)*100).toFixed(0)}}%</span>
									<span class="red"
										v-if="scope.row.dayUseCount<3">{{((scope.row.dayUseCount/10)*100).toFixed(0)}}%</span>
								</div>
							</template>
						</el-table-column>
						<el-table-column show-overflow-tooltip prop="dayUseCount" label="充电次(日)">
						</el-table-column>
						<el-table-column show-overflow-tooltip prop="monthUserCount" label="充电次(月)">
						</el-table-column>
						<el-table-column prop="equipmentStatus" label="状态">
							<template slot-scope="scope">
								<div v-if="scope.row.equipmentStatus">
									<span v-if="scope.row.equipmentInstallStatus==1">未安装</span>
									<span v-else>{{getName(scope.row.equipmentStatus,equStatusList)}}</span>
								</div>
							</template>
						</el-table-column>
						<el-table-column show-overflow-tooltip prop="equipmentJackNumber" label="插座">
						</el-table-column>
						<el-table-column prop="operate" label="操作" width="80" fixed="right">
							<template slot-scope="scope">
								<el-button v-if="scope.row.communityEquipmentNo" type="text" size="small"
									@click="itemClick(scope.row,1)">详情</el-button>
							</template>
						</el-table-column>
					</el-table>
				</div>
				<!-- <div class="pagination mypagination  mypagination2">
					<el-pagination background small :page-size="OperationInfo.pagesize"
						:current-page="OperationInfo.pagenum" :total="OperationInfo.total" :pager-count="5"
						prev-text="上一页" next-text="下一页" layout="total, prev, pager, next,jumper" ref="pagination"
						@current-change="handleCurrentChange">
					</el-pagination>
				</div>
				<div slot="footer" class="dialog-footer diabtnBox disAround">
					<el-button type="primary" @click="dialogOperation3= false">确 定</el-button>
				</div> -->
			</div>
		</el-dialog>
		<el-dialog :title="dialogTitle" center class="mydialog" :close-on-click-modal="NOfalse"
			:visible.sync="dialogVisible" width="60%">
			<el-form :model="creatObj" ref="ruleForm3" label-width="100px" class="demo-ruleForm">
				<div class="dialogBox">
					<div class="diaItem disBetween">
						<div class="diaTpye disStart">
							<el-form-item class="lableBox" label="设备编号">
								<div class="myinputBox">
									<el-input disabled v-model="creatObj.communityEquipmentNo" placeholder="请输入设备编号">
									</el-input>
								</div>
							</el-form-item>
						</div>
						<div class="diaTpye disStart">
							<el-form-item class="lableBox" label="所属社区">
								<div class="myinputBox">
									<el-input disabled v-model="creatObj.communityName" placeholder="请输入社区名称">
									</el-input>
								</div>
							</el-form-item>
						</div>
					</div>
					<div class="diaItem disBetween">
		
						<div class="diaTpye disStart">
							<el-form-item class="lableBox" label="运营状态" prop="equipmentRunStatus">
								<div class="myinputBox">
									<el-select clearable disabled v-model="creatObj.equipmentRunStatus" slot="prepend"
										placeholder="请选择运营状态">
										<el-option v-for="(item,inx) in operateStatusList" :key="inx" :label="item.text"
											:value="item.value"></el-option>
									</el-select>
								</div>
							</el-form-item>
						</div>
						<div class="diaTpye disStart">
							<el-form-item class="lableBox" label="IP地址" prop="communityEquipmentIp">
								<div class="myinputBox">
									<el-input clearable disabled v-model="creatObj.communityEquipmentIp"
										placeholder="请输入IP地址">
									</el-input>
								</div>
							</el-form-item>
						</div>
					</div>
					<div class="diaItem disBetween">
		
						<div class="diaTpye disStart">
							<el-form-item class="lableBox" label="插座规格" prop="equipmentJackNumber">
								<div class="myinputBox">
									<el-input clearable disabled v-model="creatObj.equipmentJackNumber"
										placeholder="请输入插座规格">
										<template slot="append">路</template>
									</el-input>
								</div>
							</el-form-item>
						</div>
						<div class="diaTpye disStart">
							<el-form-item class="lableBox" label="安装日期">
								<div class="myinputBox">
									<el-date-picker disabled value-format="yyyy-MM-dd"
										v-model="creatObj.equipmentInstallTime" type="date" placeholder="选择日期">
									</el-date-picker>
								</div>
							</el-form-item>
						</div>
					</div>
					<!-- <div class="diaItem disBetween">
						<div class="diaTpye disStart">
							<el-form-item class="lableBox" label="运营商" prop="equipmentServiceName">
								<div class="myinputBox">
									<el-autocomplete clearable class="inline-input"
										v-model="creatObj.equipmentServiceName" :fetch-suggestions="querySearch"
										placeholder="请输入运营商名称" @select="handleSelect">
									</el-autocomplete>
								</div>
							</el-form-item>
						</div>
					</div> -->
					<div class="diaItem disBetween">
		
						<div class="diaTpye disStart">
							<el-form-item class="lableBox" label="安装状态" prop="equipmentInstallStatus">
								<div class="myinputBox">
									<el-select disabled v-model="creatObj.equipmentInstallStatus" slot="prepend"
										placeholder="请选择安装状态">
										<el-option v-for="(item,inx) in equipmentInstallStatusList" :key="inx"
											:label="item.text" :value="item.value"></el-option>
									</el-select>
								</div>
							</el-form-item>
						</div>
						<div class="diaTpye disStart">
							<el-form-item class="lableBox" label="设备状态" prop="equipmentInstallStatus">
								<div class="myinputBox">
									<el-select disabled v-model="creatObj.equipmentStatus" slot="prepend"
										placeholder="请选择安装状态">
										<el-option v-for="(item,inx) in equStatusList" :key="inx" :label="item.text"
											:value="item.value"></el-option>
									</el-select>
								</div>
							</el-form-item>
						</div>
					</div>
					<div class="diaItem disBetween" v-if="creatObj.equipmentStatus==2">
						<div class="diaTpye disStart">
							<el-form-item class="lableBox" label="离线时间" prop="unlineTime">
								<div class="myinputBox">
									<el-input disabled v-model="creatObj.unlineTime" placeholder="">
									</el-input>
								</div>
							</el-form-item>
						</div>
						<div class="diaTpye disStart">
							<el-form-item class="lableBox" label="离线理由">
								<div class="myinputBox">
									<el-select disabled v-model="creatObj.unlineFlag" slot="prepend" placeholder="">
										<el-option v-for="(item,inx) in unlineFlagList" :key="inx" :label="item.text"
											:value="item.value"></el-option>
									</el-select>
								</div>
							</el-form-item>
						</div>
					</div>
					<div class="diaItem disBetween">
						<div class="diaTpye disStart">
							<el-form-item class="lableBox" label="所属运营商">
								<div class="myinputBox">
									<el-input disabled v-model="creatObj.equipmentServiceProvider"
										placeholder="请输入社区名称">
									</el-input>
								</div>
							</el-form-item>
						</div>
						<div class="diaTpye  disStart">
							<el-form-item class="lableBox" label="设备位置" prop="communitySiteName">
								<div class="myinputBox">
									<el-input disabled v-model="creatObj.communitySiteName" placeholder="请输入设备位置">
									</el-input>
								</div>
							</el-form-item>
						</div>
					</div>
					<div class="diaItem" v-if="creatObj.equipmentStatus==1">
						<div class="diaTpye disStart">
							插座状态
						</div>
						<div class="czBox disStart">
							<div class="czItem disStart" v-for="(item,inx) in creatObj.equipmentPortList" :key="inx">
								<div>
									<span>插座{{item.communityEquipmentPort}}：</span>
									<span
										:class="item.portStatus==1?'blue':item.portStatus==2?'green':item.portStatus==3?'red':''">{{item.portStatus==1?"空闲":item.portStatus==2?"使用中":item.portStatus==3?"故障":""}}</span>
								</div>
							</div>
						</div>
					</div>
				</div>
				<el-form-item class="diabtnBox disCenter">
					<el-button type="primary" @click="dialogVisible=false">确定</el-button>
				</el-form-item>
			</el-form>
		</el-dialog>
		
		<!--设备故障 -->
		<el-dialog :title="titles" center class="mydialog" :close-on-click-modal="NOfalse"
			:visible.sync="dialogOperation5" width="90%">
			<div class="dialogBox dialogBox2">
	
				<div class="myTable myTable2" v-loading="loading2">
					<el-table :data="tabledata" style="width: 100%" height="450" row-key="id" 
						:expand-row-keys="expandRowKeys"
						:default-expand-all="defaultAll"
						>
						<!-- <el-table-column type="index" label="序号">
						</el-table-column> -->
						<el-table-column show-overflow-tooltip prop="communityEquipmentNo" label="设备号" width="150">
						</el-table-column>
						<el-table-column show-overflow-tooltip prop="communityEquipmentPort" label="设备端口">
						</el-table-column>
						<el-table-column show-overflow-tooltip prop="portStatus" label="端口状态">
							<template slot-scope="scope">
								<span>{{scope.row.portStatus==1?"正常":scope.row.portStatus==2?"被使用":scope.row.portStatus==3?"故障":""}}</span>
							</template>
							
						</el-table-column>
						<el-table-column show-overflow-tooltip prop="faultTime" label="上报时间">
						</el-table-column>
						
						<el-table-column prop="faultType" label="故障上报类型">
							<template slot-scope="scope">
								<span>{{scope.row.faultType==1?"继电器上报":scope.row.payType==2?"充电上报":scope.row.payType==3?"状态查询上报":""}}</span>
							</template>
						</el-table-column>
						
						<el-table-column prop="operate" label="操作" width="80" >
							<template slot-scope="scope">
								<el-button v-if="scope.row.communityEquipmentNo" type="text" size="small"
									@click="itemClick(scope.row,2)">详情</el-button>
							</template>
						</el-table-column>
						
					</el-table>
				</div>
				
			</div>
		</el-dialog>
		
		
		<el-dialog :title="dialogTitlegz" center class="mydialog" :close-on-click-modal="NOfalse"
			:visible.sync="dialogVisiblegz" width="75%">
		<!-- 	<div class="disBetween diaBtnBox">
				<span class="" title="解绑" v-if="creatObj.communityId" @click.stop="itemClick(creatObj,5)">解绑</span>
				<span class="" title="复位" @click.stop="itemClick(creatObj,7)">复位</span>
			</div> -->
			<el-form :model="creatObj1" :rules="rules" ref="ruleForm4" label-width="100px" class="demo-ruleForm">
				<div class="dialogBox">
					<div class="diaItem disBetween">
						<div class="diaTpye disStart">
							<el-form-item class="lableBox" label="设备编号">
								<div class="myinputBox">
									<el-input disabled v-model="creatObj1.communityEquipmentNo" placeholder="请输入设备编号">
									</el-input>
								</div>
							</el-form-item>
						</div>
						<div class="diaTpye disStart">
							<el-form-item class="lableBox" label="所属社区">
								<div class="myinputBox">
									<el-input disabled v-model="creatObj1.communityName" placeholder="请输入社区名称">
									</el-input>
								</div>
							</el-form-item>
						</div>
					</div>
					<div class="diaItem disBetween">
		
						<div class="diaTpye disStart">
							<el-form-item class="lableBox" label="运营状态" prop="equipmentRunStatus">
								<div class="myinputBox">
									<el-select clearable :disabled="dialogVisiblegz" v-model="creatObj1.equipmentRunStatus"
										slot="prepend" placeholder="请选择运营状态">
										<el-option v-for="(item,inx) in operateStatusList" :key="inx" :label="item.text"
											:value="item.value"></el-option>
									</el-select>
								</div>
							</el-form-item>
						</div>
						<div class="diaTpye disStart">
							<el-form-item class="lableBox" label="IP地址" prop="communityEquipmentIp">
								<div class="myinputBox">
									<el-input clearable :disabled="dialogVisiblegz"
										v-model="creatObj1.communityEquipmentIp" placeholder="请输入IP地址">
									</el-input>
								</div>
							</el-form-item>
						</div>
					</div>
					<div class="diaItem disBetween">
						<div class="diaTpye disStart">
							<el-form-item class="lableBox" label="最小功率">
								<div class="myinputBox">
									<el-input clearable :disabled="dialogVisiblegz" v-model="creatObj1.equipmentMinPower"
										placeholder="">
										<template slot="append">W</template>
									</el-input>
								</div>
							</el-form-item>
						</div>
						<div class="diaTpye disStart">
							<el-form-item class="lableBox" label="最大功率">
								<div class="myinputBox">
									<el-input clearable :disabled="dialogVisiblegz" v-model="creatObj1.equipmentMaxPower"
										placeholder="">
										<template slot="append">W</template>
									</el-input>
								</div>
							</el-form-item>
						</div>
					</div>
					<div class="diaItem disBetween">
		
						<div class="diaTpye disStart">
							<el-form-item class="lableBox" label="插座规格" prop="equipmentJackNumber">
								<div class="myinputBox">
									<el-input clearable :disabled="dialogVisiblegz" v-model="creatObj1.equipmentJackNumber"
										placeholder="请输入插座规格">
										<template slot="append">路</template>
									</el-input>
								</div>
							</el-form-item>
						</div>
						<div class="diaTpye disStart">
							<el-form-item class="lableBox" label="安装日期">
								<div class="myinputBox">
									<el-date-picker disabled value-format="yyyy-MM-dd"
										v-model="creatObj1.equipmentInstallTime" type="date" placeholder="选择日期">
									</el-date-picker>
								</div>
							</el-form-item>
						</div>
					</div>
					<!-- <div class="diaItem disBetween">
						<div class="diaTpye disStart">
							<el-form-item class="lableBox" label="运营商" prop="equipmentServiceName">
								<div class="myinputBox">
									<el-autocomplete clearable class="inline-input"
										v-model="creatObj.equipmentServiceName" :fetch-suggestions="querySearch"
										placeholder="请输入运营商名称" @select="handleSelect">
									</el-autocomplete>
								</div>
							</el-form-item>
						</div>
					</div> -->
					<div class="diaItem disBetween">
		
						<div class="diaTpye disStart">
							<el-form-item class="lableBox" label="安装状态" prop="equipmentInstallStatus">
								<div class="myinputBox">
									<el-select disabled v-model="creatObj1.equipmentInstallStatus" slot="prepend"
										placeholder="请选择安装状态">
										<el-option v-for="(item,inx) in equipmentInstallStatusList" :key="inx"
											:label="item.text" :value="item.value"></el-option>
									</el-select>
								</div>
							</el-form-item>
						</div>
						<div class="diaTpye disStart">
							<el-form-item class="lableBox" label="设备状态" prop="equipmentInstallStatus">
								<div class="myinputBox">
									<el-select disabled v-model="creatObj1.equipmentStatus" slot="prepend"
										placeholder="请选择安装状态">
										<el-option v-for="(item,inx) in equStatusList" :key="inx" :label="item.text"
											:value="item.value"></el-option>
									</el-select>
								</div>
							</el-form-item>
						</div>
					</div>
					<div class="diaItem disBetween" v-if="creatObj1.equipmentStatus==2">
						<div class="diaTpye disStart">
							<el-form-item class="lableBox" label="离线时间" prop="unlineTime">
								<div class="myinputBox">
									<el-input disabled v-model="creatObj1.unlineTime" placeholder="">
									</el-input>
								</div>
							</el-form-item>
						</div>
						<div class="diaTpye disStart">
							<el-form-item class="lableBox" label="离线理由">
								<div class="myinputBox">
									<el-select disabled v-model="creatObj1.unlineFlag" slot="prepend" placeholder="">
										<el-option v-for="(item,inx) in unlineFlagList" :key="inx" :label="item.text"
											:value="item.value"></el-option>
									</el-select>
								</div>
							</el-form-item>
						</div>
					</div>
					<div class="diaItem disBetween" v-else>
						<div class="diaTpye disStart">
							<el-form-item class="lableBox" label="上次离线时间" prop="unlineTime">
								<div class="myinputBox">
									<el-input disabled v-model="creatObj1.unlineTime" placeholder="">
									</el-input>
								</div>
							</el-form-item>
						</div>
					</div>
					<div class="diaItem disBetween">
						<div class="diaTpye diaTpye2 disStart">
							<el-form-item class="lableBox" label="设备位置" prop="communitySiteName">
								<div class="myinputBox">
									<el-input disabled v-model="creatObj1.communitySiteName" placeholder="请输入设备位置">
									</el-input>
								</div>
							</el-form-item>
						</div>
					</div>
					<div class="diaItem" v-if="creatObj1.equipmentStatus==1">
						<div class="diaTpye disStart">
							插座状态
						</div>
						<div class="czBox disStart">
							<div class="czItem disStart" v-for="(item,inx) in creatObj1.equipmentPortList" :key="inx">
								<div class="disStart">
									<span>插座{{item.communityEquipmentPort}}：</span>
									<span
										:class="item.portStatus==1?'blue':item.portStatus==2?'green':item.portStatus==3?'red':''">{{item.portStatus==1?"空闲":item.portStatus==2?"使用中":item.portStatus==3?"故障":""}}</span>
									<span class="czIcon" title="复位" @click="itemClick(item,8)"></span>
								</div>
							</div>
						</div>
					</div>
				</div>
				<el-form-item class="diabtnBox disCenter" v-if="dialogVisiblegz">
					<!-- <el-button @click="dialogVisible=false">取 消</el-button>
					<el-button type="primary" @click="toSave('ruleForm3')">保 存</el-button> -->
				</el-form-item>
			</el-form>
		</el-dialog>
		
	</div>
</template>

<script type="text/javascript">
	
	export default {
		name: "statisticalAnalysis",
		data() {
			return {
				recordObj: {
					equipmentCount:"",
					equipmentNormalCount:"",
					equipmentUnNormalCount:"",
					unInstallEquipmentCount:"",
					equipmentFaultCount:"",
				},
				active: 1,
				loading2:false,
				dialogVisible:false,//设备异常
				dialogVisiblegz:false,//设备故障
				dialogTitle: "",//设备异常
				dialogTitlegz:"",//设备故障
				dialogOperation3:false,//设备异常弹框
				dialogOperation5:false,//设备故障弹框
				creatObj: {},
				creatObj1:{},
				unlineFlagList: [{
						text: "设备自动断电",
						value: 1
					},
					{
						text: "检测不到心跳",
						value: 2
					}
				],
				OperationInfo: {
					pagesize: 5,
					pagenum: 1,
					total: 0
				},
				operationData: [],
				tabledata:[],
				equStatusList: [{
						text: "正常",
						value: 1
					},
					{
						text: "离线",
						value: 2
					},
					{
						text: "故障",
						value: 3
					},
				],
				operateStatusList: [{
						text: "未投用",
						value: 1
					},
					{
						text: "运营中",
						value: 2
					},
					{
						text: "已拆除",
						value: 3
					},
				],
				equipmentInstallStatusList: [{
						text: "未安装",
						value: 1
					},
					{
						text: "已安装",
						value: 2
					},
				
				],
				expandRowKeys: [],
				defaultAll:false,
				NOfalse: false,
				titles:'',
				rules: {
					equipmentMinPower: [{
						required: true,
						message: '请输入最低充电功率',
						trigger: 'blur'
					}],
					equipmentMaxPower: [{
						required: true,
						message: '请输入最大充电功率',
						trigger: 'blur'
					}],
				},
			}
		},
		mounted() {
			this.$nextTick(() => {
				this.getData()
			})
		},
		methods: {
			getName(val, arr) {
				let obj = arr.find((item) => {
					return val == item.value
				})
				return obj.text
			},
			showErr() {
				this.$set(this.OperationInfo, "pagenum", 1)
				this.dialogOperation3 = true
				this.getErrData()
			},
			showequipmentErr(){
				this.$set(this.OperationInfo, "pagenum", 1)
				this.dialogOperation5 = true
				this.titles = '故障设备列表'
				this.getequipmentErr()
			},
			getselectCommunityEquipment(id,item,n) {
				console.log(item);
				this.$api.selectCommunityEquipment({
					communityEquipmentId: id
				}).then((res) => {
					console.log(res.obj)
					if (res.returnCode == 200) {
						if(n == 1){
							this.dialogVisible = true
							this.$set(this, "creatObj", {
								communityEquipmentNo: res.obj.communityEquipmentNo,
								communityEquipmentName: res.obj.communityEquipmentName,
								communitySiteId: res.obj.communitySiteId,
								communityEquipmentIp: res.obj.communityEquipmentIp,
								equipmentJackNumber: res.obj.equipmentJackNumber,
								equipmentServiceName: res.obj.equipmentServiceProvider,
								equipmentServiceProvider: res.obj.equipmentServiceProvider,
								equipmentRunStatus: res.obj.equipmentRunStatus,
								equipmentInstallTime: res.obj.equipmentInstallTime,
								communityEquipmentId: res.obj.communityEquipmentId,
								communityName: res.obj.communityName,
								communitySiteName: res.obj.communitySiteName,
								communityId: res.obj.communityId,
								equipmentStatus: res.obj.equipmentStatus,
								unlineTime: res.obj.unlineTime,
								unlineFlag: res.obj.unlineFlag,
								equipmentPortList: res.obj.equipmentPortList || [],
								equipmentInstallStatus: res.obj.equipmentInstallStatus || 1,
							})
							this.$nextTick(() => {
								this.$refs.ruleForm3.clearValidate()
							})
						}else if(n == 2){
							this.dialogVisiblegz = true
							this.$set(this, "creatObj1", {
								communityEquipmentNo: res.obj.communityEquipmentNo,
								communityEquipmentName: res.obj.communityEquipmentName,
								communitySiteId: res.obj.communitySiteId,
								communityEquipmentIp: res.obj.communityEquipmentIp,
								equipmentJackNumber: res.obj.equipmentJackNumber,
								equipmentServiceName: res.obj.equipmentServiceProvider,
								equipmentServiceProvider: res.obj.equipmentServiceProvider,
								equipmentRunStatus: res.obj.equipmentRunStatus,
								equipmentInstallTime: res.obj.equipmentInstallTime,
								communityEquipmentId: res.obj.communityEquipmentId,
								communityName: res.obj.communityName,
								communitySiteName: res.obj.communitySiteName,
								communityId: res.obj.communityId,
								equipmentStatus: res.obj.equipmentStatus,
								unlineTime: res.obj.unlineTime,
								unlineFlag: res.obj.unlineFlag,
								equipmentMinPower: res.obj.equipmentMinPower / 10,
								equipmentMaxPower: res.obj.equipmentMaxPower / 10,
								equipmentPortList: res.obj.equipmentPortList || [],
								equipmentInstallStatus: res.obj.equipmentInstallStatus || 1,
							})
							this.$nextTick(() => {
								this.$refs.ruleForm4.clearValidate()
							})
						}
						
					}
				})
			},
			
			// 1编辑 5新增
			openDia(item,n) {
				if(n == 1){
					console.log('设备异常信息');
					this.dialogTitle = "设备信息"
					this.getselectCommunityEquipment(item.communityEquipmentId,item,n)
				}else if(n == 2){
					console.log('设备故障信息');
					this.dialogTitlegz = '设备故障信息'
					this.getselectCommunityEquipment(item.communityEquipmentId,item,n)
				}
				
			},
			
			itemClick(item,n) {
				console.log(item);
				let that = this
				// console.log(n);
				if (n == 1) {
					console.log('1111111111');
					this.openDia(item,n)
				} else if (n == 2) {
					// this.$emit("goUrl", item)
					console.log('2222222222');
					this.openDia(item,n)
				}  else if (n == 5) {
					console.log(item)
					this.$confirm('是否确认解绑设备（' + item.communityEquipmentName + '）?', '提示', {
						confirmButtonText: '确定',
						cancelButtonText: '取消',
						type: 'warning'
					}).then(() => {
						that.$api.unbindCommunityEquipment({
							communityEquipmentId: item.communityEquipmentId
						}).then((res) => {
							console.log(res)
							if (res.returnCode == 200) {
								that.$message({
									type: 'success',
									message: '解绑成功!'
								});
								setTimeout(() => {
									this.getData1({})
									this.rushData()
								}, 500)
							}
						})
					}).catch(() => {

					});
				} else if (n == 7) {
					console.log(item)
					this.$confirm('是否确认复位设备（' + item.communityEquipmentName + '）?', '提示', {
						confirmButtonText: '确定',
						cancelButtonText: '取消',
						type: 'warning'
					}).then(() => {
						that.$api.resetCommunityEquipment({
							communityEquipmentId: item.communityEquipmentId
						}).then((res) => {
							console.log(res)
							if (res.returnCode == 200) {
								that.$message({
									type: 'success',
									message: '复位成功!'
								});
								setTimeout(() => {
									this.getData1({})
									this.rushData()
								}, 500)
							}
						})
					}).catch(() => {

					});
				} else if (n == 8) {
					// console.log(item)
					this.$confirm('是否确认复位（' + item.communityEquipmentPort + '）号插口?', '提示', {
						confirmButtonText: '确定',
						cancelButtonText: '取消',
						type: 'warning'
					}).then(() => {
						that.$api.resetCommunityEquipment({
							communityEquipmentId: item.communityEquipmentId,
							communityEquipmentPort: item.communityEquipmentPort
						}).then((res) => {
							console.log(res)
							if (res.returnCode == 200) {
								that.$message({
									type: 'success',
									message: '复位成功!'
								});
								setTimeout(() => {
									console.log('mmmmmmmm');
									this.getselectCommunityEquipment(item.communityEquipmentId,item,2)	
									this.getData()
								}, 500)
							}
						})
					}).catch(() => {

					});
				}
				// this.openDia(item)
			},
		
			unique1(arr) {
				let newArray = []
				let newArr = []
				for (let k of arr) {
					if (newArray.indexOf(k.communityId) === -1) {
						newArray.push(k.communityId)
						// this.expandRowKeys.push(k.communityId)
						newArr.push({
							id: k.communityId,
							communityName: k.communityName,
							communityId: k.communityId,
							equipmentServiceProvider: k.equipmentServiceProvider,
							children: []
						})
					}
				}
			
				return newArr
			},

			
			getErrData() {
				this.loading2 = true
				this.$api.listUnlineCommunityEquipment({}).then((res) => {
					if (res.returnCode == 200) {
						this.loading2 = false
						let arr = []
						let newArr = this.unique1(JSON.parse(JSON.stringify(res.obj)))
						for (let k of newArr) {
							for (let j of res.obj) {
								if (k.communityId == j.communityId) {
									j.communityName = ""
									j.equipmentServiceProvider = ""
									j.id = (j.communityEquipmentId + 1)
									k.children.push(j)
								}
							}
						}
						this.$set(this, "operationData", newArr || [])
					}
				})
			},
			getequipmentErr(){
				this.loading2 = true
				this.$api.listFaultCommunityEquipmentPort({}).then((res) => {
					if (res.returnCode == 200) {
						this.loading2 = false
						// let arr = []
						// let newArr = this.unique1(JSON.parse(JSON.stringify(res.obj)))
						// for (let k of newArr) {
						// 	for (let j of res.obj) {
						// 		if (k.communityId == j.communityId) {
						// 			j.communityName = ""
						// 			j.equipmentServiceProvider = ""
						// 			j.id = (j.communityEquipmentId + 1)
						// 			k.children.push(j)
						// 		}
						// 	}
						// }
						this.$set(this, "tabledata",res.obj)
					}
				})
			},
			getData() {
				this.loading=true
				this.$api.operationalStatistics({
					year: this.searchData
				}).then((res) => {
					if (res.returnCode == 200) {
						this.$set(this, "recordObj", res.obj)
					}
				})
			},
			getData1() {
				this.loading = true
				let obj = {
					communityId: this.searchObj.communityId, //社区编号
					communitySiteId: this.searchObj.communitySiteId,
					communityEquipmentNo: this.searchObj.communityEquipmentNo,
					equipmentStatus: this.searchObj.equipmentStatus,
					equipmentRunStatus: this.searchObj.equipmentRunStatus,
					pageNo: this.searchObj.pageNo, //当前页
					pageSize: this.searchObj.pageSize, //当前页个数
				}
				this.$api.listCommunityEquipment(obj).then((res) => {
					if (res.returnCode == 200) {
						this.loading = false
						this.$set(this, "tableData", res.obj.list)
						this.$set(this.PageInfo, "total", res.obj.total)
					} else {
						this.loading = false
						this.$message({
							message: res.returnMessage || "请求异常",
							type: 'error'
						});
					}
				})
			
			},
		}
	}
</script>

<style lang="scss" scoped>
	@import "./statisticalAnalysis.scss";
</style>
